import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import Slider from 'react-slick';
import Button from '../../Components/Button';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

import './SliderProdutos.scss';

function SliderProdutos() {
  const navigate = useNavigate();
  const handlePedidoClick = () => {
    const url = '/cardapio';
    window.open(url, '_self');
  };

  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);

  const handleMouseEnter = (index) => {
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };

  const produtos = [
    {
      titulo: 'Abobrinha com Cream Cheese',
      imagemUrl: 'img/pizzas/pizza_abobrinha_creamcheese.webp',
      imgHoverEffect: 'img/pizzas/pizza_abobrinha_creamcheese.webp',
      urlProduto: '',
      descricao: 'Muçarela, cream cheese, abobrinha e parmesão. Uma combinação irresistível de cremosidade e frescor, com a suavidade do cream cheese e a textura delicada da abobrinha, complementada pela muçarela derretida e o toque salgado do parmesão.',
      categoria: ['Salgada'],
      tamanho: ['Primezzita','Grande','Broto','Gigante'],
    },
    {
      titulo: 'Frango com Catupiry',
      imagemUrl: 'img/pizzas/pizza_frango_catupiry.webp',
      imgHoverEffect: 'img/pizzas/pizza_frango_catupiry.webp',
      urlProduto: 'mucarela',
      ranking: '1',
      txtTooltip: 'Sou única... Sou irresístível... Sou a mais pedida',
      descricao: 'Pizza coberta de queijo muçarela derretido sobre o nosso inigualável molho de tomate'
    },
    {
      titulo: 'Calabresa Paulistana',
      imagemUrl: 'img/pizzas/pizza_calabreza_paulistana.webp',
      imgHoverEffect: 'img/pizzas/pizza_calabreza_paulistana.webp',
      urlProduto: 'calabresa',
      ranking: '2',
      txtTooltip: 'Sou uma combinação inigualável, fala sério?!',
      descricao: 'Pizza coberta de queijo muçarela derretido sobre o nosso inigualável molho de tomate'
    },
    {
      titulo: 'Muçarela',
      imagemUrl: 'img/pizzas/pizza_cinco_queijos.webp',
      imgHoverEffect: 'img/pizzas/pizza_cinco_queijos.webp',
      urlProduto: '',
      ranking: '3',
      txtTooltip: 'Me derreto todinha por você se me chamar',
      descricao: 'Atum, cebola e Muçarela'
    },
    {
      titulo: 'Carbonara',
      imagemUrl: 'img/pizzas/pizza_carbonara.webp',
      imgHoverEffect: 'img/pizzas/pizza_carbonara.webp',
      urlProduto: '',
      ranking: '4',
      txtTooltip: 'Se seu paladar for sofisticado, me chama que eu vou',
      descricao: 'Muçarela, Creme de Leite, Bacon, Ovo e Parmesão'
    },
    {
      titulo: 'Portuguesa',
      imagemUrl: 'img/pizzas/pizza_portuguesa.webp',
      imgHoverEffect: 'img/pizzas/pizza_portuguesa.webp',
      urlProduto: '',
      ranking: '7',
      txtTooltip: 'Oras, pois!',
      descricao: 'Presunto, ovos, cebola e muçarelas'
    },
    {
      titulo: 'Pepperoni',
      imagemUrl: 'img/pizzas/pizza_pepperoni.webp',
      imgHoverEffect: 'img/pizzas/pizza_pepperoni.webp',
      urlProduto: '',
      ranking: '8',
      txtTooltip: 'Me chama que eu vou',
      descricao: 'Muçarela, Cream Cheese, Abobrinha e Parmesão'
    },
    {
      titulo: 'Peru Poró',
      imagemUrl: 'img/pizzas/pizza_peru_poro.webp',
      imgHoverEffect: 'img/pizzas/pizza_peru_poro.webp',
      urlProduto: '',
      ranking: '9',
      txtTooltip: 'Me chama que eu vou',
      descricao: 'Muçarela, Cream Cheese, Abobrinha e Parmesão'
    },
    {
      titulo: 'Caprese',
      imagemUrl: 'img/pizzas/pizza_caprese.webp',
      imgHoverEffect: 'img/pizzas/pizza_caprese.webp',
      urlProduto: '',
      ranking: '10',
      txtTooltip: 'Me chama que eu vou',
      descricao: 'Muçarela, Cream Cheese, Abobrinha e Parmesão'
    },
    // {
    //   titulo: 'Cinco Queijos',
    //   imagemUrl: 'https://pizza-prime.s3.sa-east-1.amazonaws.com/website/pizzas/pizza_cinco_queijos.webp',
    //   imgHoverEffect: 'https://pizza-prime.s3.sa-east-1.amazonaws.com/website/pizzas/pizza_cinco_queijos_2.webp',
    //   urlProduto: '',
    //   ranking: '11',
    //   txtTooltip: 'Me chama que eu vou',
    //   descricao: 'Muçarela, Cream Cheese, Abobrinha e Parmesão'
    // },
    // {
    //   titulo: 'Banana Caramelizada',
    //   imagemUrl: 'https://pizza-prime.s3.sa-east-1.amazonaws.com/website/pizzas/pizza_banana_caramelizada.webp',
    //   imgHoverEffect: 'https://pizza-prime.s3.sa-east-1.amazonaws.com/website/pizzas/pizza_banana_caramelizada_2.webp',
    //   urlProduto: '',
    //   ranking: '12',
    //   txtTooltip: 'Me chama que eu vou',
    //   descricao: 'Muçarela, Cream Cheese, Abobrinha e Parmesão'
    // },
    // {
    //   titulo: 'Chocomaltine',
    //   imagemUrl: 'https://pizza-prime.s3.sa-east-1.amazonaws.com/website/pizzas/pizza_chocomaltine.webp',
    //   imgHoverEffect: 'https://pizza-prime.s3.sa-east-1.amazonaws.com/website/pizzas/pizza_chocomaltine_2.webp',
    //   urlProduto: '',
    //   ranking: '13',
    //   txtTooltip: 'Me chama que eu vou',
    //   descricao: 'Muçarela, Cream Cheese, Abobrinha e Parmesão'
    // },
    // {
    //   titulo: 'Pepperoni com Catupiry',
    //   imagemUrl: 'https://pizza-prime.s3.sa-east-1.amazonaws.com/website/pizzas/pizza_pepperoni_catupiry.webp',
    //   imgHoverEffect: 'https://pizza-prime.s3.sa-east-1.amazonaws.com/website/pizzas/pizza_pepperoni_catupiry_2.webp',
    //   urlProduto: '',
    //   ranking: '14',
    //   txtTooltip: 'Me chama que eu vou',
    //   descricao: 'Muçarela, Cream Cheese, Abobrinha e Parmesão'
    // },
    // {
    //   titulo: 'Presunto Cream',
    //   imagemUrl: 'https://pizza-prime.s3.sa-east-1.amazonaws.com/website/pizzas/pizza_presunto_cream.webp',
    //   imgHoverEffect: 'https://pizza-prime.s3.sa-east-1.amazonaws.com/website/pizzas/pizza_presunto_cream_2.webp',
    //   urlProduto: '',
    //   ranking: '15',
    //   txtTooltip: 'Me chama que eu vou',
    //   descricao: 'Muçarela, Cream Cheese, Abobrinha e Parmesão'
    // },
    // {
    //   titulo: 'Calabresa com Catupiry',
    //   imagemUrl: 'https://pizza-prime.s3.sa-east-1.amazonaws.com/website/pizzas/pizza_frango_catupiry.webp',
    //   imgHoverEffect: 'https://pizza-prime.s3.sa-east-1.amazonaws.com/website/pizzas/pizza_frango_catupiry_2.webp',
    //   urlProduto: '',
    //   ranking: '16',
    //   txtTooltip: 'Me chama que eu vou',
    //   descricao: 'Muçarela, Cream Cheese, Abobrinha e Parmesão'
    // },
    // {
    //   titulo: 'Abobrinha com Cream Cheese',
    //   imagemUrl: 'https://pizza-prime.s3.sa-east-1.amazonaws.com/website/pizzas/pizza_abobrinha_creamcheese.webp',
    //   imgHoverEffect: 'https://pizza-prime.s3.sa-east-1.amazonaws.com/website/pizzas/pizza_abobrinha_creamcheese_2.webp',
    //   urlProduto: '',
    //   ranking: '17',
    //   txtTooltip: 'Me chama que eu vou',
    //   descricao: 'Muçarela, Cream Cheese, Abobrinha e Parmesão'
    // },
    // {
    //   titulo: 'Baiana sem Muçarela',
    //   imagemUrl: 'https://pizza-prime.s3.sa-east-1.amazonaws.com/website/pizzas/pizza_baiana_sem_muçarela.webp',
    //   imgHoverEffect: 'https://pizza-prime.s3.sa-east-1.amazonaws.com/website/pizzas/pizza_baiana_sem_muçarela_2.webp',
    //   urlProduto: '',
    //   ranking: '18',
    //   txtTooltip: 'Me chama que eu vou',
    //   descricao: 'Muçarela, Cream Cheese, Abobrinha e Parmesão'
    // },
    // {
    //   titulo: 'Búfala',
    //   imagemUrl: 'https://pizza-prime.s3.sa-east-1.amazonaws.com/website/pizzas/pizza_bufala.webp',
    //   imgHoverEffect: 'https://pizza-prime.s3.sa-east-1.amazonaws.com/website/pizzas/pizza_bufala_2.webp',
    //   urlProduto: '',
    //   ranking: '19',
    //   txtTooltip: 'Me chama que eu vou',
    //   descricao: 'Muçarela, Cream Cheese, Abobrinha e Parmesão'
    // },
  ];
  


  const settings = {
    dots: false,
    infinite: true,
    speed: 100,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    prevArrow: <FaChevronLeft className="slick-prev" />,
    nextArrow: <FaChevronRight className="slick-next" />,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };
  

  const [userLocation, setUserLocation] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const getUserLocation = () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;

            fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyB7Q5Xn66QxnfiDu-N00Cp94ISnAqVS9ck`)
              .then(response => response.json())
              .then(data => {
                const addressComponents = data.results[0].address_components;
                const stateComponent = addressComponents.find(component => component.types.includes('administrative_area_level_1'));
                const state = stateComponent ? stateComponent.short_name : 'Estado não encontrado';
                setUserLocation(state);
              })
              .catch(error => {
                console.error('Erro ao obter o endereço:', error);
                setError('Erro ao obter a localização.');
              });
          },
          (error) => {
            console.error('Erro ao obter a localização:', error);
            setError('Erro ao obter a localização.');
          }
        );
      } else {
        setError('Geolocalização não é suportada pelo navegador.');
      }
    };

    getUserLocation();
  }, []);

  return (
    <section className='sliderProdutos' id='maisPedidasSection'>
      <div className="carousel-container">
          <h1>#Top Pizzas mais pedidas</h1>
          <p>Queremos te ajudar a escolher a sua pizza de hoje. 
          <br/> Aqui estão as pizzas mais pedidas em {error ? error : userLocation ? `${userLocation}` : 'Carregando...'}</p>
        <Slider {...settings}>
         {produtos.map((produto, index) => (
  <div
    key={index}
    className={`carousel-item ${activeIndex === index ? 'item-ativado' : ''} ${hoveredIndex === index ? 'item-hovered' : ''}`}
    onMouseEnter={() => handleMouseEnter(index)}
    onMouseLeave={handleMouseLeave}
    onClick={() => setActiveIndex(index)}
  >
    <div className={`card-backEffect ${hoveredIndex === index ? 'item-hovered' : ''}`}></div>

    <Link to={produto.urlProduto || '#'}></Link>

    <div className='carousel-wrapper'>
      <div className='fotoProduto'>
        <img
          onClick={handlePedidoClick}
          className={`img-item ${activeIndex === index ? 'item-ativado' : ''} ${hoveredIndex === index ? 'item-hovered' : ''}`}
          src={hoveredIndex === index ? produto.imgHoverEffect : produto.imagemUrl}
          alt={produto.titulo}
        />

        {['Calabresa Paulistana','Pepperoni','Portuguesa'].includes(produto.titulo) && (
          <img
            src="/img/feito_com_sadia/feito_com_sadia.png"
            alt="Feito com Sadia"
            className="selo-sadia"
            loading="lazy"
          />
        )}
      </div>

      <h1 className={`${hoveredIndex === index ? 'item-hovered' : ''}`} onClick={handlePedidoClick}>
        {produto.titulo}
      </h1>
    </div>
  </div>
))}

        </Slider>

      </div>
    </section>
  );
}

export default SliderProdutos;
